import React from 'react';

const StructuredData = ({ product, breadcrumbs = [] }) => {
  if (!product) return null;

  const org = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'InsureRiskFree Solutions',
    url: 'https://insureriskfree.com',
    logo: 'https://insureriskfree.com/insure_logo_com.svg',
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+91-6364849979',
        contactType: 'customer service',
        areaServed: 'IN',
        availableLanguage: ['English', 'Hindi'],
      },
    ],
  };

  const breadcrumbList = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((b, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: b.name,
      item: b.url,
    })),
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: (product.faqs || []).map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.a,
      },
    })),
  };

  const ld = [org, breadcrumbList, faqSchema];

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }} />
  );
};

export default StructuredData;
